import script from "./MBottomBar.vue?vue&type=script&setup=true&lang=js"
export * from "./MBottomBar.vue?vue&type=script&setup=true&lang=js"

import "./MBottomBar.vue?vue&type=style&index=0&id=1f868cb2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f868cb2"]])

export default __exports__